import type { VendorDeviceSelection } from './types';
import { hasVendorDeviceSelection } from './utils';

/** 厂商设备必选校验用的虚拟字段后缀（配合 fieldPrefix 注册 hidden Form.Item） */
export const VENDOR_DEVICE_REQUIRED_FIELD_SUFFIX = '__vendorDeviceRequired';

/** 解析厂商设备必选校验字段路径 */
export function resolveVendorDeviceRequiredValidateField(fieldPrefix: string): string {
  return `${fieldPrefix}.${VENDOR_DEVICE_REQUIRED_FIELD_SUFFIX}`;
}

/** 创建厂商设备必选 Form 校验规则 */
export function createVendorDeviceSelectionRequiredRule(readSelection: () => VendorDeviceSelection | null | undefined, message: string) {
  return {
    validator(_value: unknown, callback: (error?: string) => void) {
      if (hasVendorDeviceSelection(readSelection())) {
        callback();
        return;
      }
      callback(message);
    },
  };
}
